<template>
  <AppContentLoader v-if="authStore.loading" />

  <template v-else>
    <div class="flex flex-col h-full min-h-fit">
      <AppNavbar v-if="authStore.isAuthenticated && !route.meta.hideLayout" />

      <RouterView />

      <AppFooter v-if="!route.meta.hideLayout" />
    </div>

    <Teleport to="body">
      <div class="toast-container">
        <TransitionGroup name="slide-fade">
          <ToastMessage
            v-for="toast in toastStore.toasts"
            :key="toast.id"
            :message="toast.message"
            :type="toast.type"
            @dismissed="toastStore.remove(toast.id)"
          />
        </TransitionGroup>
      </div>
    </Teleport>
  </template>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router';

import {
  AppContentLoader,
  AppFooter,
  AppNavbar,
} from '@/components/app';
import { ToastMessage } from '@/components/toasts';

import { useAuthStore, useToastStore } from '@/store';

const authStore = useAuthStore();
const toastStore = useToastStore();

const route = useRoute();
const router = useRouter();

if (route.path === '/') {
  router.push({ name: 'app_default' });
}

</script>

<style>
body {margin: 0 0 0 0 !important;}
</style>

<!--i think these styles have to be both in the transitiongroup file and scoped-->
<style scoped>
.fade.show {
  display: flex !important;
}

.slide-fade-enter-active, .slide-fade-leave-active {
  transition: transform 0.5s ease-out, opacity 0.5s ease-out;
}

.slide-fade-enter-from {
  transform: translateY(100%);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
</style>
